export default __webpack_public_path__ + "static/media/Desmond-Boateng.13ef313a.png";